<template>
  <div class="bg-blue-100">
    <div class="p-4 flex gap-2 flex-wrap">
      <img class="mx-auto md:mx-0" src="@/assets/header-logo-white.svg"/>
      <div class="flex flex-wrap gap-4 md:ml-auto">
        <div class="w-full md:w-32">
          <p class="text-white text-md font-bold text-left">Select Jurisdiction:</p>
          <div class="flex border border-gray rounded overflow-hidden items-center bg-white">
            <img v-if="currentCountry" :src="currentCountry.flag" :alt="`${currentCountry.name} flag`"
            class="w-4 h-4 mx-2">
            <div class="self-stretch border-r border-gray"></div>
            <select v-model="selectedCountryName"
            class="flex-1 text-md sm:text-base h-6"
            @input="countryChanged($event)">
              <option v-for="country in countries" :key="country.code" :value="country.name"
                class="block">
                  <div class="flex gap-2">
                    <p>{{country.name}}</p>
                  </div>
              </option>
            </select>
          </div>
        </div>
        <div class="w-full md:w-32">
          <p class="text-white text-md font-bold text-left">Select Language:</p>
          <div class="flex border border-gray rounded overflow-hidden items-center bg-white">
            <select v-model="selectedLanguage"
            class="flex-1 text-md sm:text-base h-6">
              <option v-for="language in languages" :key="language.ID" :value="language.code"
                class="block">
                <p>{{language.displayName}}</p>
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <BodyBox class="content-box">
      <div v-if="tnc.loading" class="flex flex-col gap-2 py-16">
        <p class="text-mid-gray text-xl text-center">Loading...</p>
        <font-awesome-icon icon="spinner" class="animate-spin text-xl text-orange-100"/>
      </div>
      <div v-else v-html="tnc.data"></div>
    </BodyBox>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageTitle from '@/components/PageTitle'
import BodyBox from '@/components/BodyBox'
import ExpandableRow from '@/components/ExpandableRow'

export default {
  components:{
    PageTitle,
    BodyBox,
    ExpandableRow
  },
  computed:{
    ...mapGetters({
      countries: "countries",
      currentCountry: "currentCountry",
    }),
    languages(){
      if(!this.currentCountry){
        return([])
      }
      return [
        { ID: 2, code: "en", name: "English", displayName: "English" },
        { ID: 3, code: "bm", name: "Malay", displayName: "Malay" },
      ]
      // return this.currentCountry.languages //TODO: use this once we have all the languages for tnc
    },
  },  
  data() {
    return {
      pagePath: "/privacy-policy",
      selectedIndex: 0,
      tnc: {
        loading: false,
        data: null
      },
      selectedCountryName: null,
      selectedLanguage: null,
    }
  },
  methods:{
    ...mapActions({
      getSysConfig: 'getSysConfig',
      getCountries: "getCountries",
    }),
    getDataFromConfig(){
      this.tnc = {
        loading: true,
        data: null
      }
      this.getSysConfig(`troopers_privacy_policy_${this.selectedLanguage}`)
      .then(res=>{
          this.tnc.data = res.data.value
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.tnc.loading = false
      })
    },
    countryChanged(e){
      const newCountryName = e.target.value
      const newCountry = this.countries.find(x=> x.name.toUpperCase() == newCountryName.toUpperCase())
      if(newCountry.name != this.currentCountry.name){
        document.location.href = `${newCountry.webDomain}${this.pagePath}`
      }
    }
  },
  mounted() {
    this.getCountries()
    .then(() => {
      let selectedLanguage = this.languages[0]
      if(this.$route.query.lang){
        selectedLanguage = this.languages.find(x => x.code == this.$route.query.lang.toLowerCase()) || selectedLanguage
      }
      this.selectedLanguage = selectedLanguage.code
    })
  },
  watch: {
    currentCountry(newVal){
      if(newVal){
        this.selectedCountryName = newVal.name
      }
    },
    selectedLanguage(newLanguageCode){
      const newLanguage = this.languages.find(x => x.code == newLanguageCode)
      if(newLanguage && this.$route.query?.lang != newLanguageCode){
        this.$router.push({path: this.pagePath, query: {lang: newLanguageCode}})
      }
      this.getDataFromConfig()
    }
  }
}
</script>

<style scoped>

.content-box{
  width: 100%;
  border-radius: .5em;
  position: relative;
  z-index: 1;
  font-size: .5em;
  text-align: left;
}

</style>